import { Button } from "@mui/material";
import styled from "styled-components";

export const StyledButton = styled(Button)(({ theme }) => `
  text-transform: ${theme.uptimeTextTransform.button ? theme.uptimeTextTransform.button : 'initial'} !important;
`);